import { Controller } from "@hotwired/stimulus"
import AutoNumeric from "autonumeric"

export default class extends Controller {
  connect() {
    this.autoNumeric = new AutoNumeric(this.element, {
      digitGroupSeparator: ",",
      decimalCharacter: ".",
      decimalCharacterAlternative: ",",
      currencySymbol: "$\u00a0",
      currencySymbolPlacement: AutoNumeric.options.currencySymbolPlacement.prefix,
      roundingMethod: "D",
      decimalPlaces: 2,
      selectNumberOnly: true,
      unformatOnSubmit: true,
    })
  }

  disconnect() {
    if (this.autoNumeric) {
      this.autoNumeric.remove()
    }
  }
}
